import React from "react";
import "./Sidebar.css";
//import * as FaIcons from "react-icons/fa";
import * as IoIcons from "react-icons/io";
//import * as HiIcons from "react-icons/hi";
import * as MdIcons from "react-icons/md";
import * as BsIcons from "react-icons/bs";
//import * as TbIcons from "react-icons/tb";
import * as RiIcons from "react-icons/ri";

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/Investigator/Dashboard",
    icon: <MdIcons.MdDashboard />,
    cName: "nav-text",
  }, 
  {
    title: "Orders",
    path: "/Investigator/Orders",
    icon: <RiIcons.RiLuggageCartFill />, 
    cName: "nav-text",
  }, 
  {
    title: "Reports",
    path: "/Investigator/Reports",
    icon: <BsIcons.BsBarChartLineFill />,
    cName: "nav-text",
  }, 
  {
    title: "Notifications",
    path: "/Investigator/Notifications",
    icon: <IoIcons.IoMdNotifications />,
    cName: "nav-text",
  },
  {
    title: "Logout",
    path: "/",
    icon: <RiIcons.RiLogoutCircleRLine />,
    cName: "nav-text",
  },
];
